/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      email
      name
      role
      phone
      address
      cart {
        nextToken
        __typename
      }
      orders {
        nextToken
        __typename
      }
      bookings {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      favorites {
        nextToken
        __typename
      }
      blogs {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      email
      name
      role
      phone
      address
      cart {
        nextToken
        __typename
      }
      orders {
        nextToken
        __typename
      }
      bookings {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      favorites {
        nextToken
        __typename
      }
      blogs {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      email
      name
      role
      phone
      address
      cart {
        nextToken
        __typename
      }
      orders {
        nextToken
        __typename
      }
      bookings {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      favorites {
        nextToken
        __typename
      }
      blogs {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCategory = /* GraphQL */ `
  mutation CreateCategory(
    $input: CreateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    createCategory(input: $input, condition: $condition) {
      id
      name
      description
      isActive
      displayOrder
      products {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCategory = /* GraphQL */ `
  mutation UpdateCategory(
    $input: UpdateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    updateCategory(input: $input, condition: $condition) {
      id
      name
      description
      isActive
      displayOrder
      products {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCategory = /* GraphQL */ `
  mutation DeleteCategory(
    $input: DeleteCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    deleteCategory(input: $input, condition: $condition) {
      id
      name
      description
      isActive
      displayOrder
      products {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
      name
      description
      shortDescription
      categoryId
      category {
        id
        name
        description
        isActive
        displayOrder
        createdAt
        updatedAt
        __typename
      }
      price
      discountPrice
      stock
      sku
      weight
      dimensions
      isActive
      isFeatured
      tags
      nutritionalInfo
      farmingMethod
      harvestDate
      expiryDate
      images {
        nextToken
        __typename
      }
      videos {
        nextToken
        __typename
      }
      variants {
        nextToken
        __typename
      }
      cartItems {
        nextToken
        __typename
      }
      orderItems {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      featuredProducts {
        nextToken
        __typename
      }
      favorites {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      id
      name
      description
      shortDescription
      categoryId
      category {
        id
        name
        description
        isActive
        displayOrder
        createdAt
        updatedAt
        __typename
      }
      price
      discountPrice
      stock
      sku
      weight
      dimensions
      isActive
      isFeatured
      tags
      nutritionalInfo
      farmingMethod
      harvestDate
      expiryDate
      images {
        nextToken
        __typename
      }
      videos {
        nextToken
        __typename
      }
      variants {
        nextToken
        __typename
      }
      cartItems {
        nextToken
        __typename
      }
      orderItems {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      featuredProducts {
        nextToken
        __typename
      }
      favorites {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      id
      name
      description
      shortDescription
      categoryId
      category {
        id
        name
        description
        isActive
        displayOrder
        createdAt
        updatedAt
        __typename
      }
      price
      discountPrice
      stock
      sku
      weight
      dimensions
      isActive
      isFeatured
      tags
      nutritionalInfo
      farmingMethod
      harvestDate
      expiryDate
      images {
        nextToken
        __typename
      }
      videos {
        nextToken
        __typename
      }
      variants {
        nextToken
        __typename
      }
      cartItems {
        nextToken
        __typename
      }
      orderItems {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      featuredProducts {
        nextToken
        __typename
      }
      favorites {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProductImage = /* GraphQL */ `
  mutation CreateProductImage(
    $input: CreateProductImageInput!
    $condition: ModelProductImageConditionInput
  ) {
    createProductImage(input: $input, condition: $condition) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      url
      altText
      isPrimary
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProductImage = /* GraphQL */ `
  mutation UpdateProductImage(
    $input: UpdateProductImageInput!
    $condition: ModelProductImageConditionInput
  ) {
    updateProductImage(input: $input, condition: $condition) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      url
      altText
      isPrimary
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProductImage = /* GraphQL */ `
  mutation DeleteProductImage(
    $input: DeleteProductImageInput!
    $condition: ModelProductImageConditionInput
  ) {
    deleteProductImage(input: $input, condition: $condition) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      url
      altText
      isPrimary
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProductVideo = /* GraphQL */ `
  mutation CreateProductVideo(
    $input: CreateProductVideoInput!
    $condition: ModelProductVideoConditionInput
  ) {
    createProductVideo(input: $input, condition: $condition) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      url
      title
      description
      thumbnail
      duration
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProductVideo = /* GraphQL */ `
  mutation UpdateProductVideo(
    $input: UpdateProductVideoInput!
    $condition: ModelProductVideoConditionInput
  ) {
    updateProductVideo(input: $input, condition: $condition) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      url
      title
      description
      thumbnail
      duration
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProductVideo = /* GraphQL */ `
  mutation DeleteProductVideo(
    $input: DeleteProductVideoInput!
    $condition: ModelProductVideoConditionInput
  ) {
    deleteProductVideo(input: $input, condition: $condition) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      url
      title
      description
      thumbnail
      duration
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProductVariant = /* GraphQL */ `
  mutation CreateProductVariant(
    $input: CreateProductVariantInput!
    $condition: ModelProductVariantConditionInput
  ) {
    createProductVariant(input: $input, condition: $condition) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      name
      price
      stock
      sku
      cartItems {
        nextToken
        __typename
      }
      orderItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProductVariant = /* GraphQL */ `
  mutation UpdateProductVariant(
    $input: UpdateProductVariantInput!
    $condition: ModelProductVariantConditionInput
  ) {
    updateProductVariant(input: $input, condition: $condition) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      name
      price
      stock
      sku
      cartItems {
        nextToken
        __typename
      }
      orderItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProductVariant = /* GraphQL */ `
  mutation DeleteProductVariant(
    $input: DeleteProductVariantInput!
    $condition: ModelProductVariantConditionInput
  ) {
    deleteProductVariant(input: $input, condition: $condition) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      name
      price
      stock
      sku
      cartItems {
        nextToken
        __typename
      }
      orderItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFeaturedProduct = /* GraphQL */ `
  mutation CreateFeaturedProduct(
    $input: CreateFeaturedProductInput!
    $condition: ModelFeaturedProductConditionInput
  ) {
    createFeaturedProduct(input: $input, condition: $condition) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      displayOrder
      isActive
      startDate
      endDate
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFeaturedProduct = /* GraphQL */ `
  mutation UpdateFeaturedProduct(
    $input: UpdateFeaturedProductInput!
    $condition: ModelFeaturedProductConditionInput
  ) {
    updateFeaturedProduct(input: $input, condition: $condition) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      displayOrder
      isActive
      startDate
      endDate
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFeaturedProduct = /* GraphQL */ `
  mutation DeleteFeaturedProduct(
    $input: DeleteFeaturedProductInput!
    $condition: ModelFeaturedProductConditionInput
  ) {
    deleteFeaturedProduct(input: $input, condition: $condition) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      displayOrder
      isActive
      startDate
      endDate
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCart = /* GraphQL */ `
  mutation CreateCart(
    $input: CreateCartInput!
    $condition: ModelCartConditionInput
  ) {
    createCart(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      sessionId
      items {
        nextToken
        __typename
      }
      subtotal
      tax
      shipping
      total
      discountCode
      discountAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCart = /* GraphQL */ `
  mutation UpdateCart(
    $input: UpdateCartInput!
    $condition: ModelCartConditionInput
  ) {
    updateCart(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      sessionId
      items {
        nextToken
        __typename
      }
      subtotal
      tax
      shipping
      total
      discountCode
      discountAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCart = /* GraphQL */ `
  mutation DeleteCart(
    $input: DeleteCartInput!
    $condition: ModelCartConditionInput
  ) {
    deleteCart(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      sessionId
      items {
        nextToken
        __typename
      }
      subtotal
      tax
      shipping
      total
      discountCode
      discountAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCartItem = /* GraphQL */ `
  mutation CreateCartItem(
    $input: CreateCartItemInput!
    $condition: ModelCartItemConditionInput
  ) {
    createCartItem(input: $input, condition: $condition) {
      id
      cartId
      cart {
        id
        userId
        sessionId
        subtotal
        tax
        shipping
        total
        discountCode
        discountAmount
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      variantId
      variant {
        id
        productId
        name
        price
        stock
        sku
        createdAt
        updatedAt
        __typename
      }
      quantity
      price
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCartItem = /* GraphQL */ `
  mutation UpdateCartItem(
    $input: UpdateCartItemInput!
    $condition: ModelCartItemConditionInput
  ) {
    updateCartItem(input: $input, condition: $condition) {
      id
      cartId
      cart {
        id
        userId
        sessionId
        subtotal
        tax
        shipping
        total
        discountCode
        discountAmount
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      variantId
      variant {
        id
        productId
        name
        price
        stock
        sku
        createdAt
        updatedAt
        __typename
      }
      quantity
      price
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCartItem = /* GraphQL */ `
  mutation DeleteCartItem(
    $input: DeleteCartItemInput!
    $condition: ModelCartItemConditionInput
  ) {
    deleteCartItem(input: $input, condition: $condition) {
      id
      cartId
      cart {
        id
        userId
        sessionId
        subtotal
        tax
        shipping
        total
        discountCode
        discountAmount
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      variantId
      variant {
        id
        productId
        name
        price
        stock
        sku
        createdAt
        updatedAt
        __typename
      }
      quantity
      price
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrder = /* GraphQL */ `
  mutation CreateOrder(
    $input: CreateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    createOrder(input: $input, condition: $condition) {
      id
      orderNumber
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      status
      items {
        nextToken
        __typename
      }
      shippingAddress
      billingAddress
      subtotal
      tax
      shipping
      total
      paymentMethod
      paymentStatus
      paymentId
      contactMethod
      whatsappNumber
      notes
      deliveryDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrder = /* GraphQL */ `
  mutation UpdateOrder(
    $input: UpdateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    updateOrder(input: $input, condition: $condition) {
      id
      orderNumber
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      status
      items {
        nextToken
        __typename
      }
      shippingAddress
      billingAddress
      subtotal
      tax
      shipping
      total
      paymentMethod
      paymentStatus
      paymentId
      contactMethod
      whatsappNumber
      notes
      deliveryDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrder = /* GraphQL */ `
  mutation DeleteOrder(
    $input: DeleteOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    deleteOrder(input: $input, condition: $condition) {
      id
      orderNumber
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      status
      items {
        nextToken
        __typename
      }
      shippingAddress
      billingAddress
      subtotal
      tax
      shipping
      total
      paymentMethod
      paymentStatus
      paymentId
      contactMethod
      whatsappNumber
      notes
      deliveryDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrderItem = /* GraphQL */ `
  mutation CreateOrderItem(
    $input: CreateOrderItemInput!
    $condition: ModelOrderItemConditionInput
  ) {
    createOrderItem(input: $input, condition: $condition) {
      id
      orderId
      order {
        id
        orderNumber
        userId
        status
        shippingAddress
        billingAddress
        subtotal
        tax
        shipping
        total
        paymentMethod
        paymentStatus
        paymentId
        contactMethod
        whatsappNumber
        notes
        deliveryDate
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      variantId
      variant {
        id
        productId
        name
        price
        stock
        sku
        createdAt
        updatedAt
        __typename
      }
      quantity
      price
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrderItem = /* GraphQL */ `
  mutation UpdateOrderItem(
    $input: UpdateOrderItemInput!
    $condition: ModelOrderItemConditionInput
  ) {
    updateOrderItem(input: $input, condition: $condition) {
      id
      orderId
      order {
        id
        orderNumber
        userId
        status
        shippingAddress
        billingAddress
        subtotal
        tax
        shipping
        total
        paymentMethod
        paymentStatus
        paymentId
        contactMethod
        whatsappNumber
        notes
        deliveryDate
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      variantId
      variant {
        id
        productId
        name
        price
        stock
        sku
        createdAt
        updatedAt
        __typename
      }
      quantity
      price
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrderItem = /* GraphQL */ `
  mutation DeleteOrderItem(
    $input: DeleteOrderItemInput!
    $condition: ModelOrderItemConditionInput
  ) {
    deleteOrderItem(input: $input, condition: $condition) {
      id
      orderId
      order {
        id
        orderNumber
        userId
        status
        shippingAddress
        billingAddress
        subtotal
        tax
        shipping
        total
        paymentMethod
        paymentStatus
        paymentId
        contactMethod
        whatsappNumber
        notes
        deliveryDate
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      variantId
      variant {
        id
        productId
        name
        price
        stock
        sku
        createdAt
        updatedAt
        __typename
      }
      quantity
      price
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createActivity = /* GraphQL */ `
  mutation CreateActivity(
    $input: CreateActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    createActivity(input: $input, condition: $condition) {
      id
      name
      description
      type
      duration
      price
      maxParticipants
      images
      includes
      difficulty
      seasonality
      available
      bookings {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateActivity = /* GraphQL */ `
  mutation UpdateActivity(
    $input: UpdateActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    updateActivity(input: $input, condition: $condition) {
      id
      name
      description
      type
      duration
      price
      maxParticipants
      images
      includes
      difficulty
      seasonality
      available
      bookings {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteActivity = /* GraphQL */ `
  mutation DeleteActivity(
    $input: DeleteActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    deleteActivity(input: $input, condition: $condition) {
      id
      name
      description
      type
      duration
      price
      maxParticipants
      images
      includes
      difficulty
      seasonality
      available
      bookings {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAccommodation = /* GraphQL */ `
  mutation CreateAccommodation(
    $input: CreateAccommodationInput!
    $condition: ModelAccommodationConditionInput
  ) {
    createAccommodation(input: $input, condition: $condition) {
      id
      name
      description
      type
      capacity
      pricePerNight
      images
      amenities
      available
      bookings {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAccommodation = /* GraphQL */ `
  mutation UpdateAccommodation(
    $input: UpdateAccommodationInput!
    $condition: ModelAccommodationConditionInput
  ) {
    updateAccommodation(input: $input, condition: $condition) {
      id
      name
      description
      type
      capacity
      pricePerNight
      images
      amenities
      available
      bookings {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAccommodation = /* GraphQL */ `
  mutation DeleteAccommodation(
    $input: DeleteAccommodationInput!
    $condition: ModelAccommodationConditionInput
  ) {
    deleteAccommodation(input: $input, condition: $condition) {
      id
      name
      description
      type
      capacity
      pricePerNight
      images
      amenities
      available
      bookings {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBooking = /* GraphQL */ `
  mutation CreateBooking(
    $input: CreateBookingInput!
    $condition: ModelBookingConditionInput
  ) {
    createBooking(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      bookingNumber
      type
      activityId
      activity {
        id
        name
        description
        type
        duration
        price
        maxParticipants
        images
        includes
        difficulty
        seasonality
        available
        createdAt
        updatedAt
        __typename
      }
      accommodationId
      accommodation {
        id
        name
        description
        type
        capacity
        pricePerNight
        images
        amenities
        available
        createdAt
        updatedAt
        __typename
      }
      startDate
      endDate
      guests
      totalAmount
      status
      paymentStatus
      specialRequests
      confirmationNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBooking = /* GraphQL */ `
  mutation UpdateBooking(
    $input: UpdateBookingInput!
    $condition: ModelBookingConditionInput
  ) {
    updateBooking(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      bookingNumber
      type
      activityId
      activity {
        id
        name
        description
        type
        duration
        price
        maxParticipants
        images
        includes
        difficulty
        seasonality
        available
        createdAt
        updatedAt
        __typename
      }
      accommodationId
      accommodation {
        id
        name
        description
        type
        capacity
        pricePerNight
        images
        amenities
        available
        createdAt
        updatedAt
        __typename
      }
      startDate
      endDate
      guests
      totalAmount
      status
      paymentStatus
      specialRequests
      confirmationNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBooking = /* GraphQL */ `
  mutation DeleteBooking(
    $input: DeleteBookingInput!
    $condition: ModelBookingConditionInput
  ) {
    deleteBooking(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      bookingNumber
      type
      activityId
      activity {
        id
        name
        description
        type
        duration
        price
        maxParticipants
        images
        includes
        difficulty
        seasonality
        available
        createdAt
        updatedAt
        __typename
      }
      accommodationId
      accommodation {
        id
        name
        description
        type
        capacity
        pricePerNight
        images
        amenities
        available
        createdAt
        updatedAt
        __typename
      }
      startDate
      endDate
      guests
      totalAmount
      status
      paymentStatus
      specialRequests
      confirmationNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createWorker = /* GraphQL */ `
  mutation CreateWorker(
    $input: CreateWorkerInput!
    $condition: ModelWorkerConditionInput
  ) {
    createWorker(input: $input, condition: $condition) {
      id
      name
      role
      responsibility
      phone
      address
      status
      tasks {
        nextToken
        __typename
      }
      financialRecords {
        nextToken
        __typename
      }
      loans {
        nextToken
        __typename
      }
      assignedMachinery {
        nextToken
        __typename
      }
      operatingLogs {
        nextToken
        __typename
      }
      bankAccount
      monthlySalary
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateWorker = /* GraphQL */ `
  mutation UpdateWorker(
    $input: UpdateWorkerInput!
    $condition: ModelWorkerConditionInput
  ) {
    updateWorker(input: $input, condition: $condition) {
      id
      name
      role
      responsibility
      phone
      address
      status
      tasks {
        nextToken
        __typename
      }
      financialRecords {
        nextToken
        __typename
      }
      loans {
        nextToken
        __typename
      }
      assignedMachinery {
        nextToken
        __typename
      }
      operatingLogs {
        nextToken
        __typename
      }
      bankAccount
      monthlySalary
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteWorker = /* GraphQL */ `
  mutation DeleteWorker(
    $input: DeleteWorkerInput!
    $condition: ModelWorkerConditionInput
  ) {
    deleteWorker(input: $input, condition: $condition) {
      id
      name
      role
      responsibility
      phone
      address
      status
      tasks {
        nextToken
        __typename
      }
      financialRecords {
        nextToken
        __typename
      }
      loans {
        nextToken
        __typename
      }
      assignedMachinery {
        nextToken
        __typename
      }
      operatingLogs {
        nextToken
        __typename
      }
      bankAccount
      monthlySalary
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTask = /* GraphQL */ `
  mutation CreateTask(
    $input: CreateTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    createTask(input: $input, condition: $condition) {
      id
      title
      description
      category
      priority
      status
      area
      estimatedHours
      dueDate
      completedAt
      notes
      photos
      workerId
      worker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      subtasks {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTask = /* GraphQL */ `
  mutation UpdateTask(
    $input: UpdateTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    updateTask(input: $input, condition: $condition) {
      id
      title
      description
      category
      priority
      status
      area
      estimatedHours
      dueDate
      completedAt
      notes
      photos
      workerId
      worker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      subtasks {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTask = /* GraphQL */ `
  mutation DeleteTask(
    $input: DeleteTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    deleteTask(input: $input, condition: $condition) {
      id
      title
      description
      category
      priority
      status
      area
      estimatedHours
      dueDate
      completedAt
      notes
      photos
      workerId
      worker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      subtasks {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTaskSubtaskInstance = /* GraphQL */ `
  mutation CreateTaskSubtaskInstance(
    $input: CreateTaskSubtaskInstanceInput!
    $condition: ModelTaskSubtaskInstanceConditionInput
  ) {
    createTaskSubtaskInstance(input: $input, condition: $condition) {
      id
      taskId
      task {
        id
        title
        description
        category
        priority
        status
        area
        estimatedHours
        dueDate
        completedAt
        notes
        photos
        workerId
        createdAt
        updatedAt
        __typename
      }
      title
      description
      startTime
      endTime
      duration
      area
      priority
      order
      isCompleted
      completedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTaskSubtaskInstance = /* GraphQL */ `
  mutation UpdateTaskSubtaskInstance(
    $input: UpdateTaskSubtaskInstanceInput!
    $condition: ModelTaskSubtaskInstanceConditionInput
  ) {
    updateTaskSubtaskInstance(input: $input, condition: $condition) {
      id
      taskId
      task {
        id
        title
        description
        category
        priority
        status
        area
        estimatedHours
        dueDate
        completedAt
        notes
        photos
        workerId
        createdAt
        updatedAt
        __typename
      }
      title
      description
      startTime
      endTime
      duration
      area
      priority
      order
      isCompleted
      completedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTaskSubtaskInstance = /* GraphQL */ `
  mutation DeleteTaskSubtaskInstance(
    $input: DeleteTaskSubtaskInstanceInput!
    $condition: ModelTaskSubtaskInstanceConditionInput
  ) {
    deleteTaskSubtaskInstance(input: $input, condition: $condition) {
      id
      taskId
      task {
        id
        title
        description
        category
        priority
        status
        area
        estimatedHours
        dueDate
        completedAt
        notes
        photos
        workerId
        createdAt
        updatedAt
        __typename
      }
      title
      description
      startTime
      endTime
      duration
      area
      priority
      order
      isCompleted
      completedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTaskTemplate = /* GraphQL */ `
  mutation CreateTaskTemplate(
    $input: CreateTaskTemplateInput!
    $condition: ModelTaskTemplateConditionInput
  ) {
    createTaskTemplate(input: $input, condition: $condition) {
      id
      name
      description
      dayOfWeek
      category
      role
      isActive
      subtasks {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTaskTemplate = /* GraphQL */ `
  mutation UpdateTaskTemplate(
    $input: UpdateTaskTemplateInput!
    $condition: ModelTaskTemplateConditionInput
  ) {
    updateTaskTemplate(input: $input, condition: $condition) {
      id
      name
      description
      dayOfWeek
      category
      role
      isActive
      subtasks {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTaskTemplate = /* GraphQL */ `
  mutation DeleteTaskTemplate(
    $input: DeleteTaskTemplateInput!
    $condition: ModelTaskTemplateConditionInput
  ) {
    deleteTaskTemplate(input: $input, condition: $condition) {
      id
      name
      description
      dayOfWeek
      category
      role
      isActive
      subtasks {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTaskSubtask = /* GraphQL */ `
  mutation CreateTaskSubtask(
    $input: CreateTaskSubtaskInput!
    $condition: ModelTaskSubtaskConditionInput
  ) {
    createTaskSubtask(input: $input, condition: $condition) {
      id
      templateId
      template {
        id
        name
        description
        dayOfWeek
        category
        role
        isActive
        createdAt
        updatedAt
        __typename
      }
      title
      description
      startTime
      endTime
      duration
      area
      priority
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTaskSubtask = /* GraphQL */ `
  mutation UpdateTaskSubtask(
    $input: UpdateTaskSubtaskInput!
    $condition: ModelTaskSubtaskConditionInput
  ) {
    updateTaskSubtask(input: $input, condition: $condition) {
      id
      templateId
      template {
        id
        name
        description
        dayOfWeek
        category
        role
        isActive
        createdAt
        updatedAt
        __typename
      }
      title
      description
      startTime
      endTime
      duration
      area
      priority
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTaskSubtask = /* GraphQL */ `
  mutation DeleteTaskSubtask(
    $input: DeleteTaskSubtaskInput!
    $condition: ModelTaskSubtaskConditionInput
  ) {
    deleteTaskSubtask(input: $input, condition: $condition) {
      id
      templateId
      template {
        id
        name
        description
        dayOfWeek
        category
        role
        isActive
        createdAt
        updatedAt
        __typename
      }
      title
      description
      startTime
      endTime
      duration
      area
      priority
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createInventory = /* GraphQL */ `
  mutation CreateInventory(
    $input: CreateInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    createInventory(input: $input, condition: $condition) {
      id
      productName
      currentStock
      unit
      location
      harvestDate
      expiryDate
      qualityGrade
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateInventory = /* GraphQL */ `
  mutation UpdateInventory(
    $input: UpdateInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    updateInventory(input: $input, condition: $condition) {
      id
      productName
      currentStock
      unit
      location
      harvestDate
      expiryDate
      qualityGrade
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteInventory = /* GraphQL */ `
  mutation DeleteInventory(
    $input: DeleteInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    deleteInventory(input: $input, condition: $condition) {
      id
      productName
      currentStock
      unit
      location
      harvestDate
      expiryDate
      qualityGrade
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createReview = /* GraphQL */ `
  mutation CreateReview(
    $input: CreateReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    createReview(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      activityId
      activity {
        id
        name
        description
        type
        duration
        price
        maxParticipants
        images
        includes
        difficulty
        seasonality
        available
        createdAt
        updatedAt
        __typename
      }
      accommodationId
      accommodation {
        id
        name
        description
        type
        capacity
        pricePerNight
        images
        amenities
        available
        createdAt
        updatedAt
        __typename
      }
      rating
      title
      comment
      verified
      helpful
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateReview = /* GraphQL */ `
  mutation UpdateReview(
    $input: UpdateReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    updateReview(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      activityId
      activity {
        id
        name
        description
        type
        duration
        price
        maxParticipants
        images
        includes
        difficulty
        seasonality
        available
        createdAt
        updatedAt
        __typename
      }
      accommodationId
      accommodation {
        id
        name
        description
        type
        capacity
        pricePerNight
        images
        amenities
        available
        createdAt
        updatedAt
        __typename
      }
      rating
      title
      comment
      verified
      helpful
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteReview = /* GraphQL */ `
  mutation DeleteReview(
    $input: DeleteReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    deleteReview(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      activityId
      activity {
        id
        name
        description
        type
        duration
        price
        maxParticipants
        images
        includes
        difficulty
        seasonality
        available
        createdAt
        updatedAt
        __typename
      }
      accommodationId
      accommodation {
        id
        name
        description
        type
        capacity
        pricePerNight
        images
        amenities
        available
        createdAt
        updatedAt
        __typename
      }
      rating
      title
      comment
      verified
      helpful
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFinancialRecord = /* GraphQL */ `
  mutation CreateFinancialRecord(
    $input: CreateFinancialRecordInput!
    $condition: ModelFinancialRecordConditionInput
  ) {
    createFinancialRecord(input: $input, condition: $condition) {
      id
      type
      expenseCategory
      incomeCategory
      amount
      description
      date
      workerId
      worker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      attachments
      paymentMethod
      referenceNumber
      orderId
      bookingId
      budgetId
      budget {
        id
        name
        description
        startDate
        endDate
        status
        createdAt
        updatedAt
        __typename
      }
      status
      approvedBy
      approvedAt
      isRecurring
      recurringFrequency
      parentTransactionId
      category
      reference
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFinancialRecord = /* GraphQL */ `
  mutation UpdateFinancialRecord(
    $input: UpdateFinancialRecordInput!
    $condition: ModelFinancialRecordConditionInput
  ) {
    updateFinancialRecord(input: $input, condition: $condition) {
      id
      type
      expenseCategory
      incomeCategory
      amount
      description
      date
      workerId
      worker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      attachments
      paymentMethod
      referenceNumber
      orderId
      bookingId
      budgetId
      budget {
        id
        name
        description
        startDate
        endDate
        status
        createdAt
        updatedAt
        __typename
      }
      status
      approvedBy
      approvedAt
      isRecurring
      recurringFrequency
      parentTransactionId
      category
      reference
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFinancialRecord = /* GraphQL */ `
  mutation DeleteFinancialRecord(
    $input: DeleteFinancialRecordInput!
    $condition: ModelFinancialRecordConditionInput
  ) {
    deleteFinancialRecord(input: $input, condition: $condition) {
      id
      type
      expenseCategory
      incomeCategory
      amount
      description
      date
      workerId
      worker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      attachments
      paymentMethod
      referenceNumber
      orderId
      bookingId
      budgetId
      budget {
        id
        name
        description
        startDate
        endDate
        status
        createdAt
        updatedAt
        __typename
      }
      status
      approvedBy
      approvedAt
      isRecurring
      recurringFrequency
      parentTransactionId
      category
      reference
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createWorkerLoan = /* GraphQL */ `
  mutation CreateWorkerLoan(
    $input: CreateWorkerLoanInput!
    $condition: ModelWorkerLoanConditionInput
  ) {
    createWorkerLoan(input: $input, condition: $condition) {
      id
      workerId
      worker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      amount
      purpose
      interestRate
      issueDate
      dueDate
      status
      totalRepaid
      remainingBalance
      repayments {
        nextToken
        __typename
      }
      agreement
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateWorkerLoan = /* GraphQL */ `
  mutation UpdateWorkerLoan(
    $input: UpdateWorkerLoanInput!
    $condition: ModelWorkerLoanConditionInput
  ) {
    updateWorkerLoan(input: $input, condition: $condition) {
      id
      workerId
      worker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      amount
      purpose
      interestRate
      issueDate
      dueDate
      status
      totalRepaid
      remainingBalance
      repayments {
        nextToken
        __typename
      }
      agreement
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteWorkerLoan = /* GraphQL */ `
  mutation DeleteWorkerLoan(
    $input: DeleteWorkerLoanInput!
    $condition: ModelWorkerLoanConditionInput
  ) {
    deleteWorkerLoan(input: $input, condition: $condition) {
      id
      workerId
      worker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      amount
      purpose
      interestRate
      issueDate
      dueDate
      status
      totalRepaid
      remainingBalance
      repayments {
        nextToken
        __typename
      }
      agreement
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLoanRepayment = /* GraphQL */ `
  mutation CreateLoanRepayment(
    $input: CreateLoanRepaymentInput!
    $condition: ModelLoanRepaymentConditionInput
  ) {
    createLoanRepayment(input: $input, condition: $condition) {
      id
      loanId
      loan {
        id
        workerId
        amount
        purpose
        interestRate
        issueDate
        dueDate
        status
        totalRepaid
        remainingBalance
        agreement
        notes
        createdAt
        updatedAt
        __typename
      }
      amount
      date
      method
      notes
      financialRecordId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLoanRepayment = /* GraphQL */ `
  mutation UpdateLoanRepayment(
    $input: UpdateLoanRepaymentInput!
    $condition: ModelLoanRepaymentConditionInput
  ) {
    updateLoanRepayment(input: $input, condition: $condition) {
      id
      loanId
      loan {
        id
        workerId
        amount
        purpose
        interestRate
        issueDate
        dueDate
        status
        totalRepaid
        remainingBalance
        agreement
        notes
        createdAt
        updatedAt
        __typename
      }
      amount
      date
      method
      notes
      financialRecordId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLoanRepayment = /* GraphQL */ `
  mutation DeleteLoanRepayment(
    $input: DeleteLoanRepaymentInput!
    $condition: ModelLoanRepaymentConditionInput
  ) {
    deleteLoanRepayment(input: $input, condition: $condition) {
      id
      loanId
      loan {
        id
        workerId
        amount
        purpose
        interestRate
        issueDate
        dueDate
        status
        totalRepaid
        remainingBalance
        agreement
        notes
        createdAt
        updatedAt
        __typename
      }
      amount
      date
      method
      notes
      financialRecordId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBudget = /* GraphQL */ `
  mutation CreateBudget(
    $input: CreateBudgetInput!
    $condition: ModelBudgetConditionInput
  ) {
    createBudget(input: $input, condition: $condition) {
      id
      name
      description
      startDate
      endDate
      budgetItems {
        nextToken
        __typename
      }
      transactions {
        nextToken
        __typename
      }
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBudget = /* GraphQL */ `
  mutation UpdateBudget(
    $input: UpdateBudgetInput!
    $condition: ModelBudgetConditionInput
  ) {
    updateBudget(input: $input, condition: $condition) {
      id
      name
      description
      startDate
      endDate
      budgetItems {
        nextToken
        __typename
      }
      transactions {
        nextToken
        __typename
      }
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBudget = /* GraphQL */ `
  mutation DeleteBudget(
    $input: DeleteBudgetInput!
    $condition: ModelBudgetConditionInput
  ) {
    deleteBudget(input: $input, condition: $condition) {
      id
      name
      description
      startDate
      endDate
      budgetItems {
        nextToken
        __typename
      }
      transactions {
        nextToken
        __typename
      }
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBudgetItem = /* GraphQL */ `
  mutation CreateBudgetItem(
    $input: CreateBudgetItemInput!
    $condition: ModelBudgetItemConditionInput
  ) {
    createBudgetItem(input: $input, condition: $condition) {
      id
      budgetId
      budget {
        id
        name
        description
        startDate
        endDate
        status
        createdAt
        updatedAt
        __typename
      }
      category
      type
      plannedAmount
      actualAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBudgetItem = /* GraphQL */ `
  mutation UpdateBudgetItem(
    $input: UpdateBudgetItemInput!
    $condition: ModelBudgetItemConditionInput
  ) {
    updateBudgetItem(input: $input, condition: $condition) {
      id
      budgetId
      budget {
        id
        name
        description
        startDate
        endDate
        status
        createdAt
        updatedAt
        __typename
      }
      category
      type
      plannedAmount
      actualAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBudgetItem = /* GraphQL */ `
  mutation DeleteBudgetItem(
    $input: DeleteBudgetItemInput!
    $condition: ModelBudgetItemConditionInput
  ) {
    deleteBudgetItem(input: $input, condition: $condition) {
      id
      budgetId
      budget {
        id
        name
        description
        startDate
        endDate
        status
        createdAt
        updatedAt
        __typename
      }
      category
      type
      plannedAmount
      actualAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFinancialReport = /* GraphQL */ `
  mutation CreateFinancialReport(
    $input: CreateFinancialReportInput!
    $condition: ModelFinancialReportConditionInput
  ) {
    createFinancialReport(input: $input, condition: $condition) {
      id
      name
      type
      startDate
      endDate
      reportData
      categories
      workers
      status
      generatedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFinancialReport = /* GraphQL */ `
  mutation UpdateFinancialReport(
    $input: UpdateFinancialReportInput!
    $condition: ModelFinancialReportConditionInput
  ) {
    updateFinancialReport(input: $input, condition: $condition) {
      id
      name
      type
      startDate
      endDate
      reportData
      categories
      workers
      status
      generatedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFinancialReport = /* GraphQL */ `
  mutation DeleteFinancialReport(
    $input: DeleteFinancialReportInput!
    $condition: ModelFinancialReportConditionInput
  ) {
    deleteFinancialReport(input: $input, condition: $condition) {
      id
      name
      type
      startDate
      endDate
      reportData
      categories
      workers
      status
      generatedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createNewsletter = /* GraphQL */ `
  mutation CreateNewsletter(
    $input: CreateNewsletterInput!
    $condition: ModelNewsletterConditionInput
  ) {
    createNewsletter(input: $input, condition: $condition) {
      id
      email
      name
      subscribed
      preferences
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNewsletter = /* GraphQL */ `
  mutation UpdateNewsletter(
    $input: UpdateNewsletterInput!
    $condition: ModelNewsletterConditionInput
  ) {
    updateNewsletter(input: $input, condition: $condition) {
      id
      email
      name
      subscribed
      preferences
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNewsletter = /* GraphQL */ `
  mutation DeleteNewsletter(
    $input: DeleteNewsletterInput!
    $condition: ModelNewsletterConditionInput
  ) {
    deleteNewsletter(input: $input, condition: $condition) {
      id
      email
      name
      subscribed
      preferences
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFAQ = /* GraphQL */ `
  mutation CreateFAQ(
    $input: CreateFAQInput!
    $condition: ModelFAQConditionInput
  ) {
    createFAQ(input: $input, condition: $condition) {
      id
      question
      answer
      category
      order
      active
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFAQ = /* GraphQL */ `
  mutation UpdateFAQ(
    $input: UpdateFAQInput!
    $condition: ModelFAQConditionInput
  ) {
    updateFAQ(input: $input, condition: $condition) {
      id
      question
      answer
      category
      order
      active
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFAQ = /* GraphQL */ `
  mutation DeleteFAQ(
    $input: DeleteFAQInput!
    $condition: ModelFAQConditionInput
  ) {
    deleteFAQ(input: $input, condition: $condition) {
      id
      question
      answer
      category
      order
      active
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGallery = /* GraphQL */ `
  mutation CreateGallery(
    $input: CreateGalleryInput!
    $condition: ModelGalleryConditionInput
  ) {
    createGallery(input: $input, condition: $condition) {
      id
      title
      description
      coverImage
      category
      isActive
      displayOrder
      date
      location
      images {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGallery = /* GraphQL */ `
  mutation UpdateGallery(
    $input: UpdateGalleryInput!
    $condition: ModelGalleryConditionInput
  ) {
    updateGallery(input: $input, condition: $condition) {
      id
      title
      description
      coverImage
      category
      isActive
      displayOrder
      date
      location
      images {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGallery = /* GraphQL */ `
  mutation DeleteGallery(
    $input: DeleteGalleryInput!
    $condition: ModelGalleryConditionInput
  ) {
    deleteGallery(input: $input, condition: $condition) {
      id
      title
      description
      coverImage
      category
      isActive
      displayOrder
      date
      location
      images {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGalleryImage = /* GraphQL */ `
  mutation CreateGalleryImage(
    $input: CreateGalleryImageInput!
    $condition: ModelGalleryImageConditionInput
  ) {
    createGalleryImage(input: $input, condition: $condition) {
      id
      galleryId
      gallery {
        id
        title
        description
        coverImage
        category
        isActive
        displayOrder
        date
        location
        createdAt
        updatedAt
        __typename
      }
      originalUrl
      thumbnailUrl
      altText
      caption
      order
      width
      height
      fileSize
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGalleryImage = /* GraphQL */ `
  mutation UpdateGalleryImage(
    $input: UpdateGalleryImageInput!
    $condition: ModelGalleryImageConditionInput
  ) {
    updateGalleryImage(input: $input, condition: $condition) {
      id
      galleryId
      gallery {
        id
        title
        description
        coverImage
        category
        isActive
        displayOrder
        date
        location
        createdAt
        updatedAt
        __typename
      }
      originalUrl
      thumbnailUrl
      altText
      caption
      order
      width
      height
      fileSize
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGalleryImage = /* GraphQL */ `
  mutation DeleteGalleryImage(
    $input: DeleteGalleryImageInput!
    $condition: ModelGalleryImageConditionInput
  ) {
    deleteGalleryImage(input: $input, condition: $condition) {
      id
      galleryId
      gallery {
        id
        title
        description
        coverImage
        category
        isActive
        displayOrder
        date
        location
        createdAt
        updatedAt
        __typename
      }
      originalUrl
      thumbnailUrl
      altText
      caption
      order
      width
      height
      fileSize
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserFavorite = /* GraphQL */ `
  mutation CreateUserFavorite(
    $input: CreateUserFavoriteInput!
    $condition: ModelUserFavoriteConditionInput
  ) {
    createUserFavorite(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserFavorite = /* GraphQL */ `
  mutation UpdateUserFavorite(
    $input: UpdateUserFavoriteInput!
    $condition: ModelUserFavoriteConditionInput
  ) {
    updateUserFavorite(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserFavorite = /* GraphQL */ `
  mutation DeleteUserFavorite(
    $input: DeleteUserFavoriteInput!
    $condition: ModelUserFavoriteConditionInput
  ) {
    deleteUserFavorite(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBlog = /* GraphQL */ `
  mutation CreateBlog(
    $input: CreateBlogInput!
    $condition: ModelBlogConditionInput
  ) {
    createBlog(input: $input, condition: $condition) {
      id
      title
      slug
      description
      content
      thumbnailImage
      thumbnailImageAlt
      tags {
        nextToken
        __typename
      }
      status
      isFeatured
      featuredOrder
      viewCount
      estimatedReadTime
      metaTitle
      metaDescription
      authorId
      author {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      sections {
        nextToken
        __typename
      }
      publishedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBlog = /* GraphQL */ `
  mutation UpdateBlog(
    $input: UpdateBlogInput!
    $condition: ModelBlogConditionInput
  ) {
    updateBlog(input: $input, condition: $condition) {
      id
      title
      slug
      description
      content
      thumbnailImage
      thumbnailImageAlt
      tags {
        nextToken
        __typename
      }
      status
      isFeatured
      featuredOrder
      viewCount
      estimatedReadTime
      metaTitle
      metaDescription
      authorId
      author {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      sections {
        nextToken
        __typename
      }
      publishedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBlog = /* GraphQL */ `
  mutation DeleteBlog(
    $input: DeleteBlogInput!
    $condition: ModelBlogConditionInput
  ) {
    deleteBlog(input: $input, condition: $condition) {
      id
      title
      slug
      description
      content
      thumbnailImage
      thumbnailImageAlt
      tags {
        nextToken
        __typename
      }
      status
      isFeatured
      featuredOrder
      viewCount
      estimatedReadTime
      metaTitle
      metaDescription
      authorId
      author {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      sections {
        nextToken
        __typename
      }
      publishedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBlogSection = /* GraphQL */ `
  mutation CreateBlogSection(
    $input: CreateBlogSectionInput!
    $condition: ModelBlogSectionConditionInput
  ) {
    createBlogSection(input: $input, condition: $condition) {
      id
      blogId
      blog {
        id
        title
        slug
        description
        content
        thumbnailImage
        thumbnailImageAlt
        status
        isFeatured
        featuredOrder
        viewCount
        estimatedReadTime
        metaTitle
        metaDescription
        authorId
        publishedAt
        createdAt
        updatedAt
        __typename
      }
      type
      order
      title
      content
      media {
        nextToken
        __typename
      }
      settings
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBlogSection = /* GraphQL */ `
  mutation UpdateBlogSection(
    $input: UpdateBlogSectionInput!
    $condition: ModelBlogSectionConditionInput
  ) {
    updateBlogSection(input: $input, condition: $condition) {
      id
      blogId
      blog {
        id
        title
        slug
        description
        content
        thumbnailImage
        thumbnailImageAlt
        status
        isFeatured
        featuredOrder
        viewCount
        estimatedReadTime
        metaTitle
        metaDescription
        authorId
        publishedAt
        createdAt
        updatedAt
        __typename
      }
      type
      order
      title
      content
      media {
        nextToken
        __typename
      }
      settings
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBlogSection = /* GraphQL */ `
  mutation DeleteBlogSection(
    $input: DeleteBlogSectionInput!
    $condition: ModelBlogSectionConditionInput
  ) {
    deleteBlogSection(input: $input, condition: $condition) {
      id
      blogId
      blog {
        id
        title
        slug
        description
        content
        thumbnailImage
        thumbnailImageAlt
        status
        isFeatured
        featuredOrder
        viewCount
        estimatedReadTime
        metaTitle
        metaDescription
        authorId
        publishedAt
        createdAt
        updatedAt
        __typename
      }
      type
      order
      title
      content
      media {
        nextToken
        __typename
      }
      settings
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBlogMedia = /* GraphQL */ `
  mutation CreateBlogMedia(
    $input: CreateBlogMediaInput!
    $condition: ModelBlogMediaConditionInput
  ) {
    createBlogMedia(input: $input, condition: $condition) {
      id
      sectionId
      section {
        id
        blogId
        type
        order
        title
        content
        settings
        createdAt
        updatedAt
        __typename
      }
      type
      originalUrl
      thumbnailUrl
      altText
      caption
      order
      width
      height
      fileSize
      duration
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBlogMedia = /* GraphQL */ `
  mutation UpdateBlogMedia(
    $input: UpdateBlogMediaInput!
    $condition: ModelBlogMediaConditionInput
  ) {
    updateBlogMedia(input: $input, condition: $condition) {
      id
      sectionId
      section {
        id
        blogId
        type
        order
        title
        content
        settings
        createdAt
        updatedAt
        __typename
      }
      type
      originalUrl
      thumbnailUrl
      altText
      caption
      order
      width
      height
      fileSize
      duration
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBlogMedia = /* GraphQL */ `
  mutation DeleteBlogMedia(
    $input: DeleteBlogMediaInput!
    $condition: ModelBlogMediaConditionInput
  ) {
    deleteBlogMedia(input: $input, condition: $condition) {
      id
      sectionId
      section {
        id
        blogId
        type
        order
        title
        content
        settings
        createdAt
        updatedAt
        __typename
      }
      type
      originalUrl
      thumbnailUrl
      altText
      caption
      order
      width
      height
      fileSize
      duration
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBlogTag = /* GraphQL */ `
  mutation CreateBlogTag(
    $input: CreateBlogTagInput!
    $condition: ModelBlogTagConditionInput
  ) {
    createBlogTag(input: $input, condition: $condition) {
      id
      name
      slug
      description
      color
      blogs {
        nextToken
        __typename
      }
      usageCount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBlogTag = /* GraphQL */ `
  mutation UpdateBlogTag(
    $input: UpdateBlogTagInput!
    $condition: ModelBlogTagConditionInput
  ) {
    updateBlogTag(input: $input, condition: $condition) {
      id
      name
      slug
      description
      color
      blogs {
        nextToken
        __typename
      }
      usageCount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBlogTag = /* GraphQL */ `
  mutation DeleteBlogTag(
    $input: DeleteBlogTagInput!
    $condition: ModelBlogTagConditionInput
  ) {
    deleteBlogTag(input: $input, condition: $condition) {
      id
      name
      slug
      description
      color
      blogs {
        nextToken
        __typename
      }
      usageCount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createNewsletterSubscription = /* GraphQL */ `
  mutation CreateNewsletterSubscription(
    $input: CreateNewsletterSubscriptionInput!
    $condition: ModelNewsletterSubscriptionConditionInput
  ) {
    createNewsletterSubscription(input: $input, condition: $condition) {
      id
      email
      isActive
      subscribedAt
      unsubscribedAt
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNewsletterSubscription = /* GraphQL */ `
  mutation UpdateNewsletterSubscription(
    $input: UpdateNewsletterSubscriptionInput!
    $condition: ModelNewsletterSubscriptionConditionInput
  ) {
    updateNewsletterSubscription(input: $input, condition: $condition) {
      id
      email
      isActive
      subscribedAt
      unsubscribedAt
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNewsletterSubscription = /* GraphQL */ `
  mutation DeleteNewsletterSubscription(
    $input: DeleteNewsletterSubscriptionInput!
    $condition: ModelNewsletterSubscriptionConditionInput
  ) {
    deleteNewsletterSubscription(input: $input, condition: $condition) {
      id
      email
      isActive
      subscribedAt
      unsubscribedAt
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMachinery = /* GraphQL */ `
  mutation CreateMachinery(
    $input: CreateMachineryInput!
    $condition: ModelMachineryConditionInput
  ) {
    createMachinery(input: $input, condition: $condition) {
      id
      name
      category
      brand
      model
      serialNumber
      purchaseStatus
      purchaseDate
      purchasePrice
      supplier
      warranty
      warrantyExpiry
      status
      condition
      currentValue
      location
      maintenanceCycleType
      maintenanceCycleDays
      maintenanceHours
      lastMaintenanceDate
      nextMaintenanceDate
      totalOperatingHours
      assignedWorkerId
      assignedWorker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      assignedArea
      totalMaintenanceCost
      totalOperatingCost
      fuelConsumption
      images
      documents
      notes
      specifications
      maintenanceRecords {
        nextToken
        __typename
      }
      operatingLogs {
        nextToken
        __typename
      }
      depreciationRecords {
        nextToken
        __typename
      }
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMachinery = /* GraphQL */ `
  mutation UpdateMachinery(
    $input: UpdateMachineryInput!
    $condition: ModelMachineryConditionInput
  ) {
    updateMachinery(input: $input, condition: $condition) {
      id
      name
      category
      brand
      model
      serialNumber
      purchaseStatus
      purchaseDate
      purchasePrice
      supplier
      warranty
      warrantyExpiry
      status
      condition
      currentValue
      location
      maintenanceCycleType
      maintenanceCycleDays
      maintenanceHours
      lastMaintenanceDate
      nextMaintenanceDate
      totalOperatingHours
      assignedWorkerId
      assignedWorker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      assignedArea
      totalMaintenanceCost
      totalOperatingCost
      fuelConsumption
      images
      documents
      notes
      specifications
      maintenanceRecords {
        nextToken
        __typename
      }
      operatingLogs {
        nextToken
        __typename
      }
      depreciationRecords {
        nextToken
        __typename
      }
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMachinery = /* GraphQL */ `
  mutation DeleteMachinery(
    $input: DeleteMachineryInput!
    $condition: ModelMachineryConditionInput
  ) {
    deleteMachinery(input: $input, condition: $condition) {
      id
      name
      category
      brand
      model
      serialNumber
      purchaseStatus
      purchaseDate
      purchasePrice
      supplier
      warranty
      warrantyExpiry
      status
      condition
      currentValue
      location
      maintenanceCycleType
      maintenanceCycleDays
      maintenanceHours
      lastMaintenanceDate
      nextMaintenanceDate
      totalOperatingHours
      assignedWorkerId
      assignedWorker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      assignedArea
      totalMaintenanceCost
      totalOperatingCost
      fuelConsumption
      images
      documents
      notes
      specifications
      maintenanceRecords {
        nextToken
        __typename
      }
      operatingLogs {
        nextToken
        __typename
      }
      depreciationRecords {
        nextToken
        __typename
      }
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMaintenanceRecord = /* GraphQL */ `
  mutation CreateMaintenanceRecord(
    $input: CreateMaintenanceRecordInput!
    $condition: ModelMaintenanceRecordConditionInput
  ) {
    createMaintenanceRecord(input: $input, condition: $condition) {
      id
      machineryId
      machinery {
        id
        name
        category
        brand
        model
        serialNumber
        purchaseStatus
        purchaseDate
        purchasePrice
        supplier
        warranty
        warrantyExpiry
        status
        condition
        currentValue
        location
        maintenanceCycleType
        maintenanceCycleDays
        maintenanceHours
        lastMaintenanceDate
        nextMaintenanceDate
        totalOperatingHours
        assignedWorkerId
        assignedArea
        totalMaintenanceCost
        totalOperatingCost
        fuelConsumption
        images
        documents
        notes
        specifications
        isActive
        createdAt
        updatedAt
        __typename
      }
      type
      date
      operatingHoursAtMaintenance
      description
      serviceProvider
      performedBy
      cost
      partsReplaced
      nextScheduledDate
      nextScheduledHours
      images
      invoices
      notes
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMaintenanceRecord = /* GraphQL */ `
  mutation UpdateMaintenanceRecord(
    $input: UpdateMaintenanceRecordInput!
    $condition: ModelMaintenanceRecordConditionInput
  ) {
    updateMaintenanceRecord(input: $input, condition: $condition) {
      id
      machineryId
      machinery {
        id
        name
        category
        brand
        model
        serialNumber
        purchaseStatus
        purchaseDate
        purchasePrice
        supplier
        warranty
        warrantyExpiry
        status
        condition
        currentValue
        location
        maintenanceCycleType
        maintenanceCycleDays
        maintenanceHours
        lastMaintenanceDate
        nextMaintenanceDate
        totalOperatingHours
        assignedWorkerId
        assignedArea
        totalMaintenanceCost
        totalOperatingCost
        fuelConsumption
        images
        documents
        notes
        specifications
        isActive
        createdAt
        updatedAt
        __typename
      }
      type
      date
      operatingHoursAtMaintenance
      description
      serviceProvider
      performedBy
      cost
      partsReplaced
      nextScheduledDate
      nextScheduledHours
      images
      invoices
      notes
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMaintenanceRecord = /* GraphQL */ `
  mutation DeleteMaintenanceRecord(
    $input: DeleteMaintenanceRecordInput!
    $condition: ModelMaintenanceRecordConditionInput
  ) {
    deleteMaintenanceRecord(input: $input, condition: $condition) {
      id
      machineryId
      machinery {
        id
        name
        category
        brand
        model
        serialNumber
        purchaseStatus
        purchaseDate
        purchasePrice
        supplier
        warranty
        warrantyExpiry
        status
        condition
        currentValue
        location
        maintenanceCycleType
        maintenanceCycleDays
        maintenanceHours
        lastMaintenanceDate
        nextMaintenanceDate
        totalOperatingHours
        assignedWorkerId
        assignedArea
        totalMaintenanceCost
        totalOperatingCost
        fuelConsumption
        images
        documents
        notes
        specifications
        isActive
        createdAt
        updatedAt
        __typename
      }
      type
      date
      operatingHoursAtMaintenance
      description
      serviceProvider
      performedBy
      cost
      partsReplaced
      nextScheduledDate
      nextScheduledHours
      images
      invoices
      notes
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOperatingLog = /* GraphQL */ `
  mutation CreateOperatingLog(
    $input: CreateOperatingLogInput!
    $condition: ModelOperatingLogConditionInput
  ) {
    createOperatingLog(input: $input, condition: $condition) {
      id
      machineryId
      machinery {
        id
        name
        category
        brand
        model
        serialNumber
        purchaseStatus
        purchaseDate
        purchasePrice
        supplier
        warranty
        warrantyExpiry
        status
        condition
        currentValue
        location
        maintenanceCycleType
        maintenanceCycleDays
        maintenanceHours
        lastMaintenanceDate
        nextMaintenanceDate
        totalOperatingHours
        assignedWorkerId
        assignedArea
        totalMaintenanceCost
        totalOperatingCost
        fuelConsumption
        images
        documents
        notes
        specifications
        isActive
        createdAt
        updatedAt
        __typename
      }
      date
      operatorId
      operator {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      startTime
      endTime
      hoursUsed
      area
      purpose
      fuelUsed
      fuelCost
      odometerStart
      odometerEnd
      issues
      performanceRating
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOperatingLog = /* GraphQL */ `
  mutation UpdateOperatingLog(
    $input: UpdateOperatingLogInput!
    $condition: ModelOperatingLogConditionInput
  ) {
    updateOperatingLog(input: $input, condition: $condition) {
      id
      machineryId
      machinery {
        id
        name
        category
        brand
        model
        serialNumber
        purchaseStatus
        purchaseDate
        purchasePrice
        supplier
        warranty
        warrantyExpiry
        status
        condition
        currentValue
        location
        maintenanceCycleType
        maintenanceCycleDays
        maintenanceHours
        lastMaintenanceDate
        nextMaintenanceDate
        totalOperatingHours
        assignedWorkerId
        assignedArea
        totalMaintenanceCost
        totalOperatingCost
        fuelConsumption
        images
        documents
        notes
        specifications
        isActive
        createdAt
        updatedAt
        __typename
      }
      date
      operatorId
      operator {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      startTime
      endTime
      hoursUsed
      area
      purpose
      fuelUsed
      fuelCost
      odometerStart
      odometerEnd
      issues
      performanceRating
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOperatingLog = /* GraphQL */ `
  mutation DeleteOperatingLog(
    $input: DeleteOperatingLogInput!
    $condition: ModelOperatingLogConditionInput
  ) {
    deleteOperatingLog(input: $input, condition: $condition) {
      id
      machineryId
      machinery {
        id
        name
        category
        brand
        model
        serialNumber
        purchaseStatus
        purchaseDate
        purchasePrice
        supplier
        warranty
        warrantyExpiry
        status
        condition
        currentValue
        location
        maintenanceCycleType
        maintenanceCycleDays
        maintenanceHours
        lastMaintenanceDate
        nextMaintenanceDate
        totalOperatingHours
        assignedWorkerId
        assignedArea
        totalMaintenanceCost
        totalOperatingCost
        fuelConsumption
        images
        documents
        notes
        specifications
        isActive
        createdAt
        updatedAt
        __typename
      }
      date
      operatorId
      operator {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      startTime
      endTime
      hoursUsed
      area
      purpose
      fuelUsed
      fuelCost
      odometerStart
      odometerEnd
      issues
      performanceRating
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMachineryDepreciation = /* GraphQL */ `
  mutation CreateMachineryDepreciation(
    $input: CreateMachineryDepreciationInput!
    $condition: ModelMachineryDepreciationConditionInput
  ) {
    createMachineryDepreciation(input: $input, condition: $condition) {
      id
      machineryId
      machinery {
        id
        name
        category
        brand
        model
        serialNumber
        purchaseStatus
        purchaseDate
        purchasePrice
        supplier
        warranty
        warrantyExpiry
        status
        condition
        currentValue
        location
        maintenanceCycleType
        maintenanceCycleDays
        maintenanceHours
        lastMaintenanceDate
        nextMaintenanceDate
        totalOperatingHours
        assignedWorkerId
        assignedArea
        totalMaintenanceCost
        totalOperatingCost
        fuelConsumption
        images
        documents
        notes
        specifications
        isActive
        createdAt
        updatedAt
        __typename
      }
      year
      startingValue
      depreciationAmount
      endingValue
      depreciationMethod
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMachineryDepreciation = /* GraphQL */ `
  mutation UpdateMachineryDepreciation(
    $input: UpdateMachineryDepreciationInput!
    $condition: ModelMachineryDepreciationConditionInput
  ) {
    updateMachineryDepreciation(input: $input, condition: $condition) {
      id
      machineryId
      machinery {
        id
        name
        category
        brand
        model
        serialNumber
        purchaseStatus
        purchaseDate
        purchasePrice
        supplier
        warranty
        warrantyExpiry
        status
        condition
        currentValue
        location
        maintenanceCycleType
        maintenanceCycleDays
        maintenanceHours
        lastMaintenanceDate
        nextMaintenanceDate
        totalOperatingHours
        assignedWorkerId
        assignedArea
        totalMaintenanceCost
        totalOperatingCost
        fuelConsumption
        images
        documents
        notes
        specifications
        isActive
        createdAt
        updatedAt
        __typename
      }
      year
      startingValue
      depreciationAmount
      endingValue
      depreciationMethod
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMachineryDepreciation = /* GraphQL */ `
  mutation DeleteMachineryDepreciation(
    $input: DeleteMachineryDepreciationInput!
    $condition: ModelMachineryDepreciationConditionInput
  ) {
    deleteMachineryDepreciation(input: $input, condition: $condition) {
      id
      machineryId
      machinery {
        id
        name
        category
        brand
        model
        serialNumber
        purchaseStatus
        purchaseDate
        purchasePrice
        supplier
        warranty
        warrantyExpiry
        status
        condition
        currentValue
        location
        maintenanceCycleType
        maintenanceCycleDays
        maintenanceHours
        lastMaintenanceDate
        nextMaintenanceDate
        totalOperatingHours
        assignedWorkerId
        assignedArea
        totalMaintenanceCost
        totalOperatingCost
        fuelConsumption
        images
        documents
        notes
        specifications
        isActive
        createdAt
        updatedAt
        __typename
      }
      year
      startingValue
      depreciationAmount
      endingValue
      depreciationMethod
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSupplier = /* GraphQL */ `
  mutation CreateSupplier(
    $input: CreateSupplierInput!
    $condition: ModelSupplierConditionInput
  ) {
    createSupplier(input: $input, condition: $condition) {
      id
      name
      contactPerson
      phone
      email
      address
      supplierType
      rating
      isActive
      notes
      plantings {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSupplier = /* GraphQL */ `
  mutation UpdateSupplier(
    $input: UpdateSupplierInput!
    $condition: ModelSupplierConditionInput
  ) {
    updateSupplier(input: $input, condition: $condition) {
      id
      name
      contactPerson
      phone
      email
      address
      supplierType
      rating
      isActive
      notes
      plantings {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSupplier = /* GraphQL */ `
  mutation DeleteSupplier(
    $input: DeleteSupplierInput!
    $condition: ModelSupplierConditionInput
  ) {
    deleteSupplier(input: $input, condition: $condition) {
      id
      name
      contactPerson
      phone
      email
      address
      supplierType
      rating
      isActive
      notes
      plantings {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPlanting = /* GraphQL */ `
  mutation CreatePlanting(
    $input: CreatePlantingInput!
    $condition: ModelPlantingConditionInput
  ) {
    createPlanting(input: $input, condition: $condition) {
      id
      type
      name
      variety
      zone
      location
      plantingDate
      expectedHarvestDate
      actualHarvestDate
      status
      healthStatus
      area
      waterSchedule
      lastPruned
      lastFertilized
      lastWatered
      notes
      images
      initialQuantity
      quantityUnit
      survivedQuantity
      costPerUnit
      totalCost
      currency
      supplierId
      supplier {
        id
        name
        contactPerson
        phone
        email
        address
        supplierType
        rating
        isActive
        notes
        createdAt
        updatedAt
        __typename
      }
      yieldRecords {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePlanting = /* GraphQL */ `
  mutation UpdatePlanting(
    $input: UpdatePlantingInput!
    $condition: ModelPlantingConditionInput
  ) {
    updatePlanting(input: $input, condition: $condition) {
      id
      type
      name
      variety
      zone
      location
      plantingDate
      expectedHarvestDate
      actualHarvestDate
      status
      healthStatus
      area
      waterSchedule
      lastPruned
      lastFertilized
      lastWatered
      notes
      images
      initialQuantity
      quantityUnit
      survivedQuantity
      costPerUnit
      totalCost
      currency
      supplierId
      supplier {
        id
        name
        contactPerson
        phone
        email
        address
        supplierType
        rating
        isActive
        notes
        createdAt
        updatedAt
        __typename
      }
      yieldRecords {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePlanting = /* GraphQL */ `
  mutation DeletePlanting(
    $input: DeletePlantingInput!
    $condition: ModelPlantingConditionInput
  ) {
    deletePlanting(input: $input, condition: $condition) {
      id
      type
      name
      variety
      zone
      location
      plantingDate
      expectedHarvestDate
      actualHarvestDate
      status
      healthStatus
      area
      waterSchedule
      lastPruned
      lastFertilized
      lastWatered
      notes
      images
      initialQuantity
      quantityUnit
      survivedQuantity
      costPerUnit
      totalCost
      currency
      supplierId
      supplier {
        id
        name
        contactPerson
        phone
        email
        address
        supplierType
        rating
        isActive
        notes
        createdAt
        updatedAt
        __typename
      }
      yieldRecords {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createYieldRecord = /* GraphQL */ `
  mutation CreateYieldRecord(
    $input: CreateYieldRecordInput!
    $condition: ModelYieldRecordConditionInput
  ) {
    createYieldRecord(input: $input, condition: $condition) {
      id
      plantingId
      planting {
        id
        type
        name
        variety
        zone
        location
        plantingDate
        expectedHarvestDate
        actualHarvestDate
        status
        healthStatus
        area
        waterSchedule
        lastPruned
        lastFertilized
        lastWatered
        notes
        images
        initialQuantity
        quantityUnit
        survivedQuantity
        costPerUnit
        totalCost
        currency
        supplierId
        createdAt
        updatedAt
        __typename
      }
      date
      quantity
      unit
      quality
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateYieldRecord = /* GraphQL */ `
  mutation UpdateYieldRecord(
    $input: UpdateYieldRecordInput!
    $condition: ModelYieldRecordConditionInput
  ) {
    updateYieldRecord(input: $input, condition: $condition) {
      id
      plantingId
      planting {
        id
        type
        name
        variety
        zone
        location
        plantingDate
        expectedHarvestDate
        actualHarvestDate
        status
        healthStatus
        area
        waterSchedule
        lastPruned
        lastFertilized
        lastWatered
        notes
        images
        initialQuantity
        quantityUnit
        survivedQuantity
        costPerUnit
        totalCost
        currency
        supplierId
        createdAt
        updatedAt
        __typename
      }
      date
      quantity
      unit
      quality
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteYieldRecord = /* GraphQL */ `
  mutation DeleteYieldRecord(
    $input: DeleteYieldRecordInput!
    $condition: ModelYieldRecordConditionInput
  ) {
    deleteYieldRecord(input: $input, condition: $condition) {
      id
      plantingId
      planting {
        id
        type
        name
        variety
        zone
        location
        plantingDate
        expectedHarvestDate
        actualHarvestDate
        status
        healthStatus
        area
        waterSchedule
        lastPruned
        lastFertilized
        lastWatered
        notes
        images
        initialQuantity
        quantityUnit
        survivedQuantity
        costPerUnit
        totalCost
        currency
        supplierId
        createdAt
        updatedAt
        __typename
      }
      date
      quantity
      unit
      quality
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBlogBlogTag = /* GraphQL */ `
  mutation CreateBlogBlogTag(
    $input: CreateBlogBlogTagInput!
    $condition: ModelBlogBlogTagConditionInput
  ) {
    createBlogBlogTag(input: $input, condition: $condition) {
      id
      blogId
      blogTagId
      blog {
        id
        title
        slug
        description
        content
        thumbnailImage
        thumbnailImageAlt
        status
        isFeatured
        featuredOrder
        viewCount
        estimatedReadTime
        metaTitle
        metaDescription
        authorId
        publishedAt
        createdAt
        updatedAt
        __typename
      }
      blogTag {
        id
        name
        slug
        description
        color
        usageCount
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBlogBlogTag = /* GraphQL */ `
  mutation UpdateBlogBlogTag(
    $input: UpdateBlogBlogTagInput!
    $condition: ModelBlogBlogTagConditionInput
  ) {
    updateBlogBlogTag(input: $input, condition: $condition) {
      id
      blogId
      blogTagId
      blog {
        id
        title
        slug
        description
        content
        thumbnailImage
        thumbnailImageAlt
        status
        isFeatured
        featuredOrder
        viewCount
        estimatedReadTime
        metaTitle
        metaDescription
        authorId
        publishedAt
        createdAt
        updatedAt
        __typename
      }
      blogTag {
        id
        name
        slug
        description
        color
        usageCount
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBlogBlogTag = /* GraphQL */ `
  mutation DeleteBlogBlogTag(
    $input: DeleteBlogBlogTagInput!
    $condition: ModelBlogBlogTagConditionInput
  ) {
    deleteBlogBlogTag(input: $input, condition: $condition) {
      id
      blogId
      blogTagId
      blog {
        id
        title
        slug
        description
        content
        thumbnailImage
        thumbnailImageAlt
        status
        isFeatured
        featuredOrder
        viewCount
        estimatedReadTime
        metaTitle
        metaDescription
        authorId
        publishedAt
        createdAt
        updatedAt
        __typename
      }
      blogTag {
        id
        name
        slug
        description
        color
        usageCount
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSuggestionCategory = /* GraphQL */ `
  mutation CreateSuggestionCategory(
    $input: CreateSuggestionCategoryInput!
    $condition: ModelSuggestionCategoryConditionInput
  ) {
    createSuggestionCategory(input: $input, condition: $condition) {
      id
      name
      displayName
      description
      icon
      color
      isActive
      order
      createdAt
      updatedAt
      suggestions {
        nextToken
        __typename
      }
      stats {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateSuggestionCategory = /* GraphQL */ `
  mutation UpdateSuggestionCategory(
    $input: UpdateSuggestionCategoryInput!
    $condition: ModelSuggestionCategoryConditionInput
  ) {
    updateSuggestionCategory(input: $input, condition: $condition) {
      id
      name
      displayName
      description
      icon
      color
      isActive
      order
      createdAt
      updatedAt
      suggestions {
        nextToken
        __typename
      }
      stats {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteSuggestionCategory = /* GraphQL */ `
  mutation DeleteSuggestionCategory(
    $input: DeleteSuggestionCategoryInput!
    $condition: ModelSuggestionCategoryConditionInput
  ) {
    deleteSuggestionCategory(input: $input, condition: $condition) {
      id
      name
      displayName
      description
      icon
      color
      isActive
      order
      createdAt
      updatedAt
      suggestions {
        nextToken
        __typename
      }
      stats {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createWorkerRole = /* GraphQL */ `
  mutation CreateWorkerRole(
    $input: CreateWorkerRoleInput!
    $condition: ModelWorkerRoleConditionInput
  ) {
    createWorkerRole(input: $input, condition: $condition) {
      id
      name
      displayName
      description
      isActive
      order
      createdAt
      updatedAt
      suggestions {
        nextToken
        __typename
      }
      stats {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateWorkerRole = /* GraphQL */ `
  mutation UpdateWorkerRole(
    $input: UpdateWorkerRoleInput!
    $condition: ModelWorkerRoleConditionInput
  ) {
    updateWorkerRole(input: $input, condition: $condition) {
      id
      name
      displayName
      description
      isActive
      order
      createdAt
      updatedAt
      suggestions {
        nextToken
        __typename
      }
      stats {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteWorkerRole = /* GraphQL */ `
  mutation DeleteWorkerRole(
    $input: DeleteWorkerRoleInput!
    $condition: ModelWorkerRoleConditionInput
  ) {
    deleteWorkerRole(input: $input, condition: $condition) {
      id
      name
      displayName
      description
      isActive
      order
      createdAt
      updatedAt
      suggestions {
        nextToken
        __typename
      }
      stats {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createSubtaskSuggestion = /* GraphQL */ `
  mutation CreateSubtaskSuggestion(
    $input: CreateSubtaskSuggestionInput!
    $condition: ModelSubtaskSuggestionConditionInput
  ) {
    createSubtaskSuggestion(input: $input, condition: $condition) {
      id
      title
      description
      duration
      priority
      estimatedCost
      requiredSkills
      tools
      safetyNotes
      order
      isActive
      createdAt
      updatedAt
      categoryId
      roleId
      category {
        id
        name
        displayName
        description
        icon
        color
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      role {
        id
        name
        displayName
        description
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      usageCount
      lastUsed
      __typename
    }
  }
`;
export const updateSubtaskSuggestion = /* GraphQL */ `
  mutation UpdateSubtaskSuggestion(
    $input: UpdateSubtaskSuggestionInput!
    $condition: ModelSubtaskSuggestionConditionInput
  ) {
    updateSubtaskSuggestion(input: $input, condition: $condition) {
      id
      title
      description
      duration
      priority
      estimatedCost
      requiredSkills
      tools
      safetyNotes
      order
      isActive
      createdAt
      updatedAt
      categoryId
      roleId
      category {
        id
        name
        displayName
        description
        icon
        color
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      role {
        id
        name
        displayName
        description
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      usageCount
      lastUsed
      __typename
    }
  }
`;
export const deleteSubtaskSuggestion = /* GraphQL */ `
  mutation DeleteSubtaskSuggestion(
    $input: DeleteSubtaskSuggestionInput!
    $condition: ModelSubtaskSuggestionConditionInput
  ) {
    deleteSubtaskSuggestion(input: $input, condition: $condition) {
      id
      title
      description
      duration
      priority
      estimatedCost
      requiredSkills
      tools
      safetyNotes
      order
      isActive
      createdAt
      updatedAt
      categoryId
      roleId
      category {
        id
        name
        displayName
        description
        icon
        color
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      role {
        id
        name
        displayName
        description
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      usageCount
      lastUsed
      __typename
    }
  }
`;
export const createSuggestionStats = /* GraphQL */ `
  mutation CreateSuggestionStats(
    $input: CreateSuggestionStatsInput!
    $condition: ModelSuggestionStatsConditionInput
  ) {
    createSuggestionStats(input: $input, condition: $condition) {
      id
      categoryId
      roleId
      totalSuggestions
      activeSuggestions
      mostUsedSuggestion
      averageUsage
      lastUpdated
      category {
        id
        name
        displayName
        description
        icon
        color
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      role {
        id
        name
        displayName
        description
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSuggestionStats = /* GraphQL */ `
  mutation UpdateSuggestionStats(
    $input: UpdateSuggestionStatsInput!
    $condition: ModelSuggestionStatsConditionInput
  ) {
    updateSuggestionStats(input: $input, condition: $condition) {
      id
      categoryId
      roleId
      totalSuggestions
      activeSuggestions
      mostUsedSuggestion
      averageUsage
      lastUpdated
      category {
        id
        name
        displayName
        description
        icon
        color
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      role {
        id
        name
        displayName
        description
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSuggestionStats = /* GraphQL */ `
  mutation DeleteSuggestionStats(
    $input: DeleteSuggestionStatsInput!
    $condition: ModelSuggestionStatsConditionInput
  ) {
    deleteSuggestionStats(input: $input, condition: $condition) {
      id
      categoryId
      roleId
      totalSuggestions
      activeSuggestions
      mostUsedSuggestion
      averageUsage
      lastUpdated
      category {
        id
        name
        displayName
        description
        icon
        color
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      role {
        id
        name
        displayName
        description
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
